/***
 *
 *   HOME NAV
 *   Navigation used on the main external website. Renders a dashboard link
 *   if the user is signed in, or sign in / sign up if they are not.
 *
 **********/

import { Fragment, useContext } from 'react';
import { AuthContext } from 'app/auth';
import { Icon, Link, useTheme } from 'components/lib';
import Style from './home.tailwind.js';
import { useTranslate } from 'app/translations.js';
import { rootPath } from 'utilities/routes.js';
import { LanguageSwitcher } from './languageSwitcher';

// in-page anchors to the landing sections
const SECTIONS = [
    { id: 'capabilities', label: 'landing.nav.features' },
    { id: 'integrations', label: 'landing.nav.integrations' },
    { id: 'intake', label: 'landing.nav.intake' },
    { id: 'contact', label: 'landing.nav.contact' },
];

export function HomeNav(props) {
    const { _t } = useTranslate();
    const context = useContext(AuthContext);
    const { isDark, toggleTheme } = useTheme();

    return (
        <header className={Style.wrapper}>
            <div className={Style.inner}>
                {/* alt="" — the adjacent wordmark already names the link */}
                <Link url={rootPath('/')} color="brand" className={Style.logo}>
                    <img src="/assets/icon.png" alt="" className={Style.logoMark} />
                    Valetify
                </Link>

                {/* section anchors only make sense on the landing page itself */}
                {props.anchors && (
                    <nav className={Style.nav}>
                        {SECTIONS.map((section) => (
                            <a key={section.id} href={`#${section.id}`} className={Style.link}>
                                {_t(section.label)}
                            </a>
                        ))}
                    </nav>
                )}

                <div className={Style.actions}>
                    <LanguageSwitcher />
                    <button
                        type="button"
                        onClick={toggleTheme}
                        className={Style.theme}
                        title={_t(isDark ? 'landing.nav.theme.toLight' : 'landing.nav.theme.toDark')}
                        aria-label={_t(
                            isDark ? 'landing.nav.theme.toLight' : 'landing.nav.theme.toDark'
                        )}>
                        <Icon image={isDark ? 'sun' : 'moon'} size={16} />
                    </button>

                    {context.user?.onboarded ? (
                        <Link
                            url={rootPath('/app/tickets')}
                            color="white"
                            text={_t('dashboard.label')}
                            className={Style.cta}
                        />
                    ) : (
                        <Fragment>
                            <Link
                                url={rootPath('/signin')}
                                color="primary"
                                text={_t('signin.label')}
                                className={Style.signin}
                            />
                            <Link
                                url={rootPath('/signup')}
                                color="white"
                                text={_t('landing.nav.getStarted')}
                                className={Style.cta}
                            />
                        </Fragment>
                    )}
                </div>
            </div>
        </header>
    );
}
